import { isEmpty } from "lodash";

export const getQueryString: (
  query: { [k: string]: string } | URLSearchParams,
) => string = (query) => {
  if (!query || isEmpty(query)) {
    return "";
  }
  return Object.entries(query)
    .reduce<string[]>((acc: string[], [k, v]): string[] => {
      const q = Array.isArray(v)
        ? v
            .reduce<string[]>((ac, sv) => {
              const queryParam = `${k}=${sv}`;
              ac.push(queryParam);
              return ac;
            }, [])
            .join("&")
        : `${k}=${v}`;
      acc.push(q);
      return acc;
    }, [])
    .join("&");
};
